import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import {
  StartFinanceApplication,
  StartFinanceApplicationVariables,
} from '../../../checkout3/common/graphql/mutations/__generated__/StartFinanceApplication';
import financeApplication from '../../../checkout3/common/graphql/mutations/startFinanceApplication';
import useWidgetContext from '../../../../common/react/useWidgetContext';
import errorHandler from '../../service/errorHandler';

export const useFinanceApplication = (dealId: string, noRedirection?: boolean) => {
  const {
    configuration: { financeApplicationUrl },
  } = useWidgetContext();
  const [initFinanceApp, { loading }] = useMutation<StartFinanceApplication, StartFinanceApplicationVariables>(
    financeApplication.START,
  );
  const initFinanceApplication = useCallback(async () => {
    try {
      const {
        data: {
          startFinanceApplication: { code: financeApplicationCode },
        },
      } = await initFinanceApp({ variables: { dealId } });

      if (financeApplicationCode && !noRedirection) {
        window.location.href = `${financeApplicationUrl}?token=${dealId}`;
      }
    } catch (err) {
      errorHandler.handleError(err);
    }
  }, [dealId, noRedirection]);

  return {
    initFinanceApplication,
    loading,
  };
};
